import ControlFactory from '@/Factories/ControlFactory';
import AssociationMultiDropDown from '@/Controls/AssociationMultiDropDown';
import AssociationMultiDropDownViewModel from '@/ViewModels/Controls/AssociationMultiDropDownViewModel';
import AssociationMultiDropDownViewModelT from '@/ViewModels/Controls/AssociationMultiDropDownViewModel';
import MultiSelectDropDownListViewModelT from '@/ViewModels/Controls/MultiSelectDropDownListViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import Config from '@/Management/GlobalConfiguration';
import Loader from '@/Utility/Loader';
import ResourceManager from '@/Management/ResourceManager';
import FilterHelper from '@/Utility/FilterHelper';
import LocatorHelper from '@/Utility/LocatorHelper';
import * as StringFormatter from '@/Utility/StringFormatter';
import Utilities from '@/Utility/Utilities';
export default class AssociationMultiDropDownFactory extends ControlFactory {
    /** @overrides */
    public control: AssociationMultiDropDown;
    /** @overrides */
    public viewModel: AssociationMultiDropDownViewModel;
    private jQueryControl: JQuery;
    public orderStatement: string;
    public lazyLoading: boolean;
    public isOpen: boolean;
    public defaultIterator: any;
    public dataIterator: any;
    public iterator: any;
    public isModalCreating: any;
    /**
    * Enthält die ausgewählten Werte des DropDowns (vollständig, inkl. ObjectIdentValue)
    */
    public entireValues: any;
    public forceReloadData: any;
    private dataBusy: any;
    private valueBusy: any;
    private AssociationMultiDropDownViewModel: any;
    private AssociationMultiDropDown: any;
    private ObjectDisconnectionHelper: any;
    private _objectHelper: any;
    private MultiSelectDropDownListViewModel: any;
    protected LinkViewModel: any;
    protected ImageViewModel: any;
    protected LabelViewModel: any;
    private dataLoaded: any;
    private valuesLoaded: any;
    constructor(protected params: any) {
        super(params);
        this.jQueryControl = null;
        this.dataBusy = this.observableOrDefault(false);
        this.valueBusy = this.observableOrDefault(false);
        this.defaultIterator = this.context.defaultIterators[this.detailViewItem.name];
        this.dataIterator = null;
        this.iterator = null;
        this.isModalCreating = this.paramOrDefault(params.isModalCreating, false);
        let setBusy = () => {
            let isBusy = this.dataBusy() || this.valueBusy();
            this.isBusy(isBusy);
        };
        this.defineSubscription(this.dataBusy, setBusy);
        this.defineSubscription(this.valueBusy, setBusy);
        this.AssociationMultiDropDownViewModel = ComponentManager.getViewModel<typeof AssociationMultiDropDownViewModelT>('AssociationMultiDropDownViewModel');
        this.AssociationMultiDropDown = ComponentManager.getControl('AssociationMultiDropDown');
        this.ObjectDisconnectionHelper = ComponentManager.getUtility('ObjectDisconnectionHelper');
        this._objectHelper = null;
        this.MultiSelectDropDownListViewModel = ComponentManager.getViewModel<typeof MultiSelectDropDownListViewModelT>('MultiSelectDropDownListViewModel');
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.dataLoaded = this.observableOrDefault(false);
        this.valuesLoaded = this.observableOrDefault(false);
        this.entireValues = this.observableOrDefault([]);
        this.registerForMessageId('RefreshAssociationsMessage', () => {
            this.refresh();
        });
    }
    public remove: (removed: any) => void;
    public removeAll: () => void;
    public notifyDetailViewClosed(topdTypeName?: any, toPDOID?: any): void {
        this.viewModel.multiSelectDropDownList.data.evaluate();
        let oldValues = this.viewModel.multiSelectDropDownList.values();
        this.viewModel.multiSelectDropDownList.values.evaluate().then((newValues) => {
            if (oldValues.length != newValues.length || _.difference(newValues, oldValues).length > 0) {
                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                this.context.notifyFactoryRefreshed(this.detailViewItem);
            }
        });
        this.viewModel.multiSelectDropDownList.values.evaluate();
    }
    /** @overrides */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        // falls kein this.orderStatement �bergeben wird, wird sp�ter nach ObjectIdentValue sortiert
        //this.orderStatement = this.paramOrDefault(this.params.orderStatement, this.detailViewItem.listView.defaultOrder);
        this.orderStatement = this.paramOrDefault(this.params.orderStatement, '');
        this.lazyLoading = this.paramOrDefault(this.params.lazyLoading, true);
        this.forceReloadData = false;
        this.isOpen = this.paramOrDefault(this.params.isOpen, false);
        let resolvedErgName = ResourceManager.getInstance().get(this.detailViewItem.tooltip);
        let data = this.defineAsyncComputed(() => {
            if (this.lazyLoading && !this.isOpen && !this.forceReloadData) {
                return [];
            }
            let ret = null;
            ko.ignoreDependencies(() => {
                this.dataBusy(true);
                this.dataLoaded(false);
                this.forceReloadData = false;
                this.deleteIterators([this.dataIterator]);
                ret = RADEnvironmentProxy.getInstance().createIteratorWithOperator({
                    pdTypeName: this.detailViewItem.listView.typeName,
                    properties: ['ObjectIdentValue'],
                    filter: JSON.stringify(FilterHelper.createFilterObjectForStaticFilter(this.detailViewItem.listView.staticFilterExpression)),
                    orderby: this.convertOrderStatementWithoutAssociation(this.orderStatement),
                    retrieveExtentCount: true,
                    contextPDO_ID: this.context.genericObject.pdoId,
                    itOperator: {
                        includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                        includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                        includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                        memoryOptimizationEnabled: true,
                        onlySubPrincipals: null,
                        historizationDates: null,
                        isGridIterator: null,
                        principalFilter: null,
                        searchObjectPositionRequest: null,
                        visibleDeletedObjects: null,
                        hideConnectedElementsRequest: null
                    }
                }).then((iterator) => {
                    this.dataIterator = iterator;
                    if (this.isDisposed === false && +iterator.extentCount > 0) {
                        return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                            iteratorID: iterator.id,
                            start: 0,
                            end: +iterator.extentCount - 1
                        });
                    }
                    return null;
                }).then((arrayOfGeneric) => {
                    if (this.isDisposed === false && arrayOfGeneric != null) {
                        let result = [];
                        // wenn kein this.orderStatement �bergeben wurde, wird jetzt nach ObjectIdentValue sortiert.
                        if (this.orderStatement === '') {
                            arrayOfGeneric = arrayOfGeneric.sort((a, b) => {
                                if (a[1].toLowerCase() < b[1].toLowerCase())
                                    return -1;
                                if (a[1].toLowerCase() > b[1].toLowerCase())
                                    return 1;
                                return 0;
                            });
                        }
                        for (let i = 0; i < arrayOfGeneric.length; i++) {
                            result.push({
                                pdoId: arrayOfGeneric[i][0],
                                objectIdentValue: StringFormatter.escapeHtml(arrayOfGeneric[i][1], true),
                                dummy: false
                            });
                        }
                        return result;
                    }
                    return null;
                }).then((result) => {
                    if (this.isDisposed === false && result != null) {
                        this.async(() => {
                            if (this.isDisposed === false && this.viewModel != null) {
                                this.viewModel.multiSelectDropDownList.values.valueHasMutated();
                            }
                        });
                        if (!result)
                            result = [];
                        return result;
                    }
                    return [];
                });
                ret.always(() => {
                    if (!this.isDisposed) {
                        this.dataBusy(false);
                        this.dataLoaded(true);
                    }
                });
            });
            return ret;
        }, []);
        let getIterator = () => {
            return RADEnvironmentProxy.getInstance().createIteratorForAssoziation({
                pdTypeName: this.context.genericObject.pdTypeName,
                pdo_id: this.context.genericObject.pdoId,
                assoziationName: this.detailViewItem.name,
                properties: ['ObjectIdentValue'],
                retrieveExtentCount: true,
                orderby: this.convertOrderStatementWithAssociation(this.orderStatement),
                itOperator: {
                    includeAllPrincipals: this.detailViewItem.listView.includeAllPrincipals,
                    includeBasePrincipals: this.detailViewItem.listView.includeBasePrincipals,
                    includeSubPrincipals: this.detailViewItem.listView.includeSubPrincipals,
                    memoryOptimizationEnabled: true,
                    onlySubPrincipals: null,
                    historizationDates: null,
                    isGridIterator: null,
                    principalFilter: null,
                    searchObjectPositionRequest: null,
                    visibleDeletedObjects: null,
                    hideConnectedElementsRequest: null
                },
                filter: ''
            });
        }
        let values = this.defineAsyncComputed((): any => {
            this.valueBusy(true);
            this.valuesLoaded(false);
            this.deleteIterators([this.iterator]);
            let ret = $.when(getIterator()).then((iterator) => {
                this.iterator = iterator;
                if (this.isDisposed === false && this.iterator.extentCount > 0) {
                    return RADEnvironmentProxy.getInstance().getExtentWithPDOIDAsFirstColumn({
                        iteratorID: this.iterator.id,
                        start: 0,
                        end: this.iterator.extentCount - 1
                    });
                }
                return null;
            }).then((arrayOfGeneric) => {
                if (this.isDisposed === false && arrayOfGeneric != null) {
                    let result = [];
                    // wenn kein this.orderStatement übergeben wurde, wird jetzt nach ObjectIdentValue sortiert.
                    if (this.orderStatement === '') {
                        arrayOfGeneric = arrayOfGeneric.sort((a, b) => {
                            if (a[1].toLowerCase() < b[1].toLowerCase())
                                return -1;
                            if (a[1].toLowerCase() > b[1].toLowerCase())
                                return 1;
                            return 0;
                        });
                    }
                    for (let i = 0; i < arrayOfGeneric.length; i++) {
                        result.push({
                            pdoId: arrayOfGeneric[i][0],
                            objectIdentValue: StringFormatter.escapeHtml(arrayOfGeneric[i][1], true)
                        });
                    }
                    return result;
                }
                return null;
            }).then((result) => {
                if (this.isDisposed === true)
                    return [];
                if (result) {
                    if (this.isOpen === false && this.viewModel.multiSelectDropDownList.data().length === 0) {
                        this.viewModel.multiSelectDropDownList.data(result);
                    }
                    if (this.isOpen === true) {
                        this.async(() => {
                            if (this.isDisposed === false && this.viewModel != null) {
                                this.viewModel.multiSelectDropDownList.values.valueHasMutated();
                            }
                        });
                    }
                    this.entireValues(result);
                    let ids = _.map(result, 'pdoId');
                    return ids;
                }
                result = [];
                this.entireValues(result);
                return result;
            });
            ret.always(() => {
                if (!this.isDisposed) {
                    this.valueBusy(false);
                    this.valuesLoaded(true);
                }
            });
            return ret;
        }, []);
        let dataTextField = 'objectIdentValue';
        let dataValueField = 'pdoId';
        let multiSelectDropDownlist = new this.MultiSelectDropDownListViewModel({
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            data: data,
            values: values,
            dataTextField: dataTextField,
            dataValueField: dataValueField,
            onAdded: (added) => {
                this.OnConnection(added);
            },
            onRemoved: (removed) => {
                if (this.isDisposed === false && this.isOpen === true) {
                    this.remove(removed);
                }
            },
            onOpen: () => {
                if (this.isDisposed === false) {
                    this.isOpen = true;
                    if (((this.lazyLoading && !this.dataLoaded()) || !Utilities.isNullOrUndefinedOrBlank(this.detailViewItem.listView.staticFilterExpression)) && !this.dataBusy()) {
                        return this.viewModel.multiSelectDropDownList.data.evaluate();
                    }
                    else {
                        return Utilities.resolveImmediately(null);
                    }
                }
                return Utilities.resolveImmediately(null);
            },
            onClose: () => {
                if (this.isDisposed === false && this.isOpen === true) {
                    this.isOpen = false;
                }
            },
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            invalidationText: this.invalidationText,
            tooltip: new this.LabelViewModel({
                caption: resolvedErgName
            }),
            isBusy: this.isBusy
        });
        this.removeAll = () => {
            let values = this.viewModel.multiSelectDropDownList.values();
            if (values.length > 0)
                this.remove(this.viewModel.multiSelectDropDownList.values());
        }
        this.viewModel = (() => {
            return new this.AssociationMultiDropDownViewModel({
                factory: this,
                isRequired: this.isRequired,
                isEnabled: this.isEnabled,
                isValid: this.isValid,
                isBusy: this.isBusy,
                multiSelectDropDownList: multiSelectDropDownlist,
                linkCreate: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.create'),
                    tooltip: new this.LabelViewModel({
                        ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                    }),
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: LocatorHelper.buildLocator(this.detailViewItem.name, 'link.create.image'),
                        source: Config.inlineImages.OBJ_CREATE,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    onClick: () => {
                        let associationName = this.detailViewItem.listView.relationName;
                        $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'connect', { toPdoIds: [null] }))
                            .then((doUpdateAssociation) => {
                                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                                    this.context.createContext(this, this.detailViewItem.listView, null, null, null, null, this.isModalCreating);
                                }
                            });
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonCreate;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true,
                    isEnabled: this.isEnabled
                }),
                disconnectAll: this.removeAll,
            });
        })();
        this.remove = (removed) => {
            let removedArray = Array.isArray(removed) ? removed : [removed];
            let disconnectionHelper = new this.ObjectDisconnectionHelper({
                contextPdoId: this.context.genericObject.pdoId,
                associationName: this.detailViewItem.listView.relationName,
                pdTypeName: this.detailViewItem.listView.typeName,
                affectedObjectIds: removedArray,
                disconnectionCallback: () => {
                    this.OnDisconnectionCallback(removedArray);
                },
                confirmDeletionCallback: (dialogResult) => {
                    this.OnConfirmDeletionCallback(dialogResult, removed);
                }
            });
            disconnectionHelper.ExecuteCheck();
        };
        this.defineComputed(() => {
            let data = this.viewModel.multiSelectDropDownList.data();
            let values = this.entireValues();
            if (data && values && (data.length > 0 || values.length > 0)) {
                if (this.dataLoaded() && this.valuesLoaded()) {
                    // Bereits hinzugefügte Dummies inital entfernen
                    data = data.filter((d) => { return d.dummy === false; });
                    values.forEach((value) => {
                        let found = _.find(data, (item) => { return item["pdoId"] == value["pdoId"] });
                        if (!found) {
                            let newItem = {
                                pdoId: value["pdoId"],
                                objectIdentValue: value["objectIdentValue"],
                                dummy: true
                            };
                            data.push(newItem);
                        }
                    });
                    this.viewModel.multiSelectDropDownList.data(data);
                }
            }
        });
        this.control = (() => {
            return new this.AssociationMultiDropDown(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.registerObservableValidation(this.viewModel.multiSelectDropDownList.values);
        return this.jQueryControl;
    }
    /** @implements */
    public refresh(): void {
        this.forceReloadData = true;
        this.viewModel.multiSelectDropDownList.data.evaluate();
        this.viewModel.multiSelectDropDownList.values.evaluate();
    }
    public convertOrderStatementWithAssociation(orderBy: any): any {
        if (orderBy == null) {
            return null;
        }
        // TODO: Diese Logik würde "this.AndereRelation.Sortierung" in "this.MeineRelation.AndereRelation.Sortierung" ändern, dies wäre nicht korrekt.
        let relation = this.detailViewItem.listView.relationName + '.';
        return orderBy.replace(new RegExp('this.(?!' + relation + ')', 'g'), 'this.' + relation);
    }
    public deleteIterators(iterators: any): any {
        if (this.isDisposed || iterators == null) {
            return;
        }
        iterators = iterators.filter((it) => { return it != null; });
        if (iterators != null && iterators.length > 0) {
            RADEnvironmentProxy.getInstance().deleteIterators({
                iteratorIDs: iterators.map((it) => { return parseInt(it.id); })
            });
        }
    }
    
    protected disposeInternal(): void {
        this.deleteIterators([this.defaultIterator, this.dataIterator, this.iterator]);
        super.disposeInternal();
    }
    
    private OnConnection(objectIdToConnect: any): any {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'connect', { toPdoIds: [objectIdToConnect] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    let contextId = this.context.genericObject.pdoId;
                    if (+contextId > 0) {
                        RADEnvironmentProxy.getInstance().connect({
                            pdoID: contextId,
                            assoziationName: this.detailViewItem.listView.relationName,
                            topdTypeName: this.detailViewItem.listView.typeName,
                            toPDOID: objectIdToConnect,
                            nestedContextName: this.context.getNestedContextPath()
                        }).then((changeObject) => {
                            if (this.validateStatus(changeObject)) {
                                this.context.genericObject.isModified(true);
                                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                            }
                        }).always(() => {
                            this.viewModel.multiSelectDropDownList.values.evaluate();
                            Loader.getInstance().hide();
                            this.RemoveObjectHelper();
                        });
                    } else {
                        RADEnvironmentProxy.getInstance().getObject({
                            pdTypeName: this.detailViewItem.listView.typeName,
                            pdoID: objectIdToConnect,
                            properties: ['ObjectIdentValue']
                        }).then((genericDTO) => {
                        }).always(() => {
                            Loader.getInstance().hide();
                            this.RemoveObjectHelper();
                        });
                    }
                }
            });
    }
    private OnDisconnectionCallback(pdoIds: any): any {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'disconnect', { toPdoIds: pdoIds }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    RADEnvironmentProxy.getInstance().disconnectMany({
                        pdoID: this.context.genericObject.pdoId,
                        assoziationName: this.detailViewItem.listView.relationName,
                        topdTypeName: this.detailViewItem.listView.typeName,
                        toPDOIDs: pdoIds,
                        nestedContextName: this.context.getNestedContextPath()
                    }).then((changeObject) => {
                        if (this.isDisposed !== false) return;
                        if (this.validateStatus(changeObject)) {
                            this.context.genericObject.isModified(true);
                            this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                            this.context.notifyFactoryRefreshed(this.detailViewItem);
                        }
                    }).always(() => {
                        this.viewModel.multiSelectDropDownList.values.evaluate();
                        Loader.getInstance().hide();
                    });
                }
            });
    }
    private OnConfirmDeletionCallback(dialogResult: any, pdoId: any): any {
        if (dialogResult === true) {
            let associationName = this.detailViewItem.listView.relationName;
            $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'disconnectAndDelete', { toPdoIds: [pdoId] }))
                .then((doUpdateAssociation) => {
                    if (doUpdateAssociation == null || doUpdateAssociation === true) {
                        Loader.getInstance().show();
                        let pdTypeName = this.detailViewItem.listView.typeName;
                        RADEnvironmentProxy.getInstance().deleteObject({
                            pdTypeName: pdTypeName,
                            pdoID: pdoId
                        }).then((changeObject) => {
                            if (this.isDisposed !== false) return;
                            if (this.validateStatus(changeObject)) {
                                this.context.genericObject.isModified(true);
                                this.context.notifyUpdatedAssociation(associationName);
                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                                if (this._objectHelper) {
                                    this._objectHelper.ExecuteAction();
                                }
                            }
                        }).always(() => {
                            this.viewModel.multiSelectDropDownList.values.evaluate();
                            this.RemoveObjectHelper();
                            Loader.getInstance().hide();
                        });
                    }
                });
        }
        else {
            this.RemoveObjectHelper();
        }
    }
    private RemoveObjectHelper(): any {
        if (this._objectHelper && !this._objectHelper.isDisposed) {
            this._objectHelper.dispose();
            this._objectHelper = null;
        }
    }
}

ComponentManager.setFactory('AssociationMultiDropDown', AssociationMultiDropDownFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');